const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const INSTANCE = process.env.REACT_APP_BRANCH_NAME;

export { BASE_URL, INSTANCE };
